import React, { useState } from "react";
import {
  AccountCircle,
  FactCheck,
  Lock,
  MonitorHeart,
  Security,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { loginUser } from "../services/owdedApi";
import "./Login.scss";

function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mfaCode, setMfaCode] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (event) => {
    event.preventDefault();
    setError("");
    setLoading(true);

    try {
      const data = await loginUser({ email, password, mfa_code: mfaCode });
      login(data.token, data.user);
      navigate("/dashboard", { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || "Identifiants invalides ou serveur indisponible.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-left">
        <div className="login-logo">
          <span className="login-mark">
            
          <img src="/OWSUR.png" className="sidebar-brand__img" alt="Client" />
          </span>
          <span>
            <strong>OWSUR-MATADI</strong>
            <small>SYSTEME DE GESTION DES INVESTISSEMENTS</small>
          </span>
        </div>

        <div className="login-features">
          <article>
            <Security />
            <div>
              <strong>Sécurisé</strong>
              <span>Protection avancée des opérations et des accès</span>
            </div>
          </article>
          <article>
            <MonitorHeart />
            <div>
              <strong>Surveillance 24/7</strong>
              <span>Suivi en temps réel du portefeuille et du recouvrement</span>
            </div>
          </article>
          <article>
            <FactCheck />
            <div>
              <strong>Traçabilité</strong>
              <span>Journalisation complète des validations et paiements</span>
            </div>
          </article>
        </div>

        <div className="login-visual-lock">
          <Lock />
        </div>
      </div>

      <div className="login-content">
        <div className="language-pill">🇫🇷 Français</div>
        <form className="login-form" onSubmit={handleLogin}>
          <div className="login-form__brand">
            <span>
              <img src="/OWSUR.png" className="sidebar-brand__img" alt="Client" />
              
            </span>
            <h1>OWSUR-MATADI</h1>
            <p>Connexion à votre espace sécurisé</p>
          </div>

          <div className="form-divider" />

          <label className="form-group">
            <span>Nom d'utilisateur ou email</span>
            <div className="input-shell">
              <AccountCircle />
            <input
              type="email"
              placeholder="Entrez votre nom d'utilisateur ou email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              required
            />
            </div>
          </label>
          <label className="form-group">
            <span>Mot de passe</span>
            <div className="input-shell password-group">
              <Lock />
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Entrez votre mot de passe"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
            />
            <button type="button" className="toggle-password" onClick={() => setShowPassword((value) => !value)}>
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </button>
            </div>
          </label>
          <div className="login-form__row">
            <label><input type="checkbox" /> Se souvenir de moi</label>
            <button type="button">Mot de passe oublié ?</button>
          </div>
          {error && <p className="error-text">{error}</p>}
          <button className="btn-login" disabled={loading}>
            <Lock />
            {loading ? "Connexion..." : "Connexion sécurisée"}
          </button>
          <p className="login-footnote">Accès réservé aux utilisateurs autorisés uniquement</p>
        </form>
      </div>
    </div>
  );
}

export default Login;
